// John Eldhose 20200729
import React, { Component } from 'react';
import { Star, StarBorder, StarHalf } from '@material-ui/icons';

class RatingShow extends Component {
  content = (star, rating) => {
    if((star - .5) === rating)
      return <StarHalf style={{ color: 'gold' }} />;
    else if(star <= rating)
      return <Star style={{ color: 'gold' }} />;
    else
      return <StarBorder style={{ color: 'gold' }} />;
  }
  render() {
    if(this.props.ratingcount === 0)
      return <div />;
    else {
      var rating = Math.floor(((this.props.ratingsum / this.props.ratingcount) * 10) / 5) / 2;
      return (
        <div>
          {this.content(1, rating)}
          {this.content(2, rating)}
          {this.content(3, rating)}
          {this.content(4, rating)}
          {this.content(5, rating)}
        </div>
      );
    }
  }
}

export default RatingShow;



// WEBPACK FOOTER //
// ./src/components/home/academy/RatingShow.js